import { createFeatureSelector } from '@ngrx/store';

import type { State } from './customer-entity.reducer';

export const customerEntityFeatureKey = 'customerEntity';

export const getCustomerEntityStateSelector = createFeatureSelector<State>(
  customerEntityFeatureKey
);
